import React, { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { useReactToPrint } from 'react-to-print'
import moment from 'moment'

import '../scss/Allowance.scss'
import { PrintAllowance } from '../components/PrintAllowance'

const AllowanceModal = ({ values, show, handleClose }) => {
  const noticeRef = useRef() // 沒有買受人統編印 PrintNotice

  useEffect(() => {
    return () => {

    }
  }, [values])

  
  const printNotice = useReactToPrint({
    content: () => noticeRef.current,
  })



  return (
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      {!values && (
        <Modal.Header closeButton>
          <Modal.Title>查詢中...</Modal.Title>
        </Modal.Header>
      )}

      {values && values.data && (
        <>
          <Modal.Header closeButton>
            <Modal.Title>查詢結果</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <div className="modal_group">
              <div className="col-lg-2 modal_label">
                <span>折讓單號碼</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{values.data.idno}</span>
              </div>
              <div className="col-lg-2 modal_label">
                <span>折讓單日期</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{values.data.date ? moment(values.data.date).format('YYYY/MM/DD') : ''}</span>
              </div>              
            </div>

            <div className="modal_group">
              <div className="col-lg-2 modal_label">
                <span>原發票號碼</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{values.data.invoice_no}</span>
              </div>

              <div className="col-lg-2 modal_label">
                <span>原發票日期</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{moment(values.data.invoice_date).format('YYYY/MM/DD')}</span>
              </div>
            </div>


            <div className="modal_group">
              <div className="col-lg-2 modal_label">
                <span>折讓金額</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{values.data.total_amount}</span>
              </div>
            </div>

            <div className="modal_group">
              <div className="col-lg-2 modal_label">
                <span>買受人統編</span>
              </div>
              <div className="col-lg-2 help_block">
                <span>{values.data.buyer_vat ? values.data.buyer_vat : 'N/A'}</span>
              </div>
            </div>


          </Modal.Body>

          <div className="buttonContent">


            <button className="btn btn-info btnItem" onClick={printNotice}>
            列印證明聯
            </button>


          </div>

          {/* Hide */}
          <div className="print">
            <PrintAllowance printInfo={values.data} ref={noticeRef} />
          </div>

        </>
      )}

      {values && !values.data && (
        <Modal.Header closeButton>
          <Modal.Title>{values.message}</Modal.Title>
        </Modal.Header>
      )}
    </Modal>
  )
}

export default AllowanceModal
